/**
 *
 * Modal
 *
 */
import React, { memo } from 'react';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Heading,
  Stack,
  Box,
} from '@chakra-ui/react';

import { customTheme } from '../../../../theme';
import { modalCloseButtonIconStyles } from '../../DataEntry/Button/styles';

import { IModalProps } from './types';

export const CustomModal = memo((props: IModalProps) => {
  const {
    styles,
    body,
    header,
    isOpen,
    footer,
    onClose,
    closeButton = true,
    ...rest
  } = props;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      blockScrollOnMount={false}
      scrollBehavior="inside"
      size="sm"
      {...styles?.modal}
      {...rest}
    >
      <ModalOverlay {...styles?.overlay} />
      <ModalContent borderRadius={12} {...styles?.content}>
        {header && (
          <Stack spacing={0}>
            <ModalHeader
              //borderBottom={'1px solid'}
              //borderColor={'gray.100'}
              pb={0}
              {...styles?.header}
            >
              {header}
            </ModalHeader>
            <Box px={6} w="full" pt={3}>
              <Box
                borderBottom={'1px solid'}
                borderColor={customTheme.colors.gray['100']}
              />
            </Box>
          </Stack>
        )}
        {closeButton && <ModalCloseButton {...modalCloseButtonIconStyles} />}
        <ModalBody pt={4} pb={6} px={8} w="full" h="full" {...styles?.body}>
          {body}
        </ModalBody>
        {footer && <ModalFooter {...styles?.footer}>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
});
